// 搜索图标
export const SEARCH_ICON = 'https://osscdn2.zhongheschool.com/common/defaultType/202401/202401231435070667.png';